import React, { createContext, useEffect, useState, useContext, ReactNode } from 'react';
import axios from 'axios';
import { API_ENDPOINTS } from 'assets/api/endpoints';

// Define the context type

type CaptchaConfig = {
	action: string;
	enabled: boolean;
	version: 'V2' | 'V3';
};
interface CaptchaConfigContextType {
	CaptchaConfigs: CaptchaConfig[] | [];
}
// Create context with a default undefined value
const CaptchaConfigContext = createContext<CaptchaConfigContextType | undefined>(undefined);

export const CaptchaConfig: React.FC<{ children: ReactNode }> = ({ children }) => {
	const [CaptchaConfigs, setCaptchaConfigs] = useState<CaptchaConfig[] | []>([]);

	useEffect(() => {
		const fetcCaptchaConfig = async () => {
			try {
				const response = await axios.get(API_ENDPOINTS.getRecaptchaConfig);
				setCaptchaConfigs(response.data);
			} catch (error) {
				console.error('Failed to fetch holiday status', error);
			}
		};
		fetcCaptchaConfig();
	}, []);

	return <CaptchaConfigContext.Provider value={{ CaptchaConfigs }}>{children}</CaptchaConfigContext.Provider>;
};

// Custom hook to expose the holiday context
export const useCaptchaConfigs = (): CaptchaConfigContextType => {
	const context = useContext(CaptchaConfigContext);
	if (!context) {
		throw new Error('useCaptchaConfigs must be used within a CaptchaConfigsProvider');
	}
	return context;
};
